import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/v1/auth';

export class AuthService implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async signIn(params: types.SignInParameters): Promise<types.SignInResponse> {
    const { data } = await this.axios.post<types.SignInResponse>(`/v1/auth/signin/`, params.body);
    return data;
  }

  async signOut(params: types.SignOutParameters): Promise<void> {
    await this.axios.post<types.SignInResponse>(`/v1/auth/signout/`);
  }
}
